export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6588.7a9316f0.jpg";